import { render, staticRenderFns } from "./PayrollClosingDate.vue?vue&type=template&id=3cb4922c&"
import script from "./PayrollClosingDate.vue?vue&type=script&lang=ts&"
export * from "./PayrollClosingDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PayrollClosingDate.vue"
export default component.exports